import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import "@/styles/index.scss"; // 全局引入reset css
import router from "./router";
import VueLuckyCanvas from "@lucky-canvas/vue"; // 抽奖组件
import { Switch } from 'vant';
import vConsole from 'vconsole'
import { onCheckHasConsole } from './libs/utils'

Vue.config.productionTip = false;
Vue.use(VueLuckyCanvas);
Vue.use(Switch);

// if (onCheckHasConsole()) {
  // new vConsole();
// }

require("@/libs/rem.js"); // 引入全局rem函数
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
